import React from 'react';

export class Header extends React.Component {
  render() {
    return (
      <div id="Header" className="h-80 bg-cover bg-header-fullhd"></div>
    );
  }
}
